import './assets/css/global.less'; //全局css
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import Main from './component/main/index.jsx';
import Store from './redux/store';

ReactDOM.render(( 
	<Provider store = { Store } >
	    <BrowserRouter>
	    <Switch>
	    	<Route path = '/' component = { Main }/> 
	    </Switch>
	    </BrowserRouter> 
    </Provider>
), document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js